import React from "react";
import { Helmet } from "react-helmet-async";
// import Content1 from "./content1";
// import Content6 from "./content6";
// import Content7 from "./content7";
import Content4 from "./content4";
import Content5 from "./content5";
import Content8 from "./content8";
// import Content9 from "./content9";
// import Content10 from "./content10";
import TestimonialSlider from "./testimonal";
// import MotoDoctorBenefits from "./benifits";
import Hero from "./hero";
// import FAQ from "./faq";
// import KeyServices from "./keyServices";
import HowItWorks from "./howItWorks";
import BoxSlider from "./review";
import WhyChooseUs from "./whyMotoDoctor";
// import QuickAccess from "./quickAccess";
// import ContactUs from "./contactUs";
// import PickupDrop from "./pickupDrop";
// import Mission from "./benifits";
// import ServiceCommitment from "./keyServices";
function Home() {
  return (
    <div id="Home">
      {/* home-page */}
      <Helmet>
        {/* TITLE + DESCRIPTION */}
        <title>Bike Service Repair Chennai | Roadside Assistance in Chennai | MotoDoctor</title>

        <meta
          name="description"
          content="24/7 bike service and bike repair in Chennai. Flat tire, battery trouble or breakdown? Get instant roadside help and towing anytime."
        />

        {/* CANONICAL ADDED HERE */}
        <link rel="canonical" href="https://www.motodoctor.in/" />

        {/* H1 + H2 meta */}
        <meta name="heading" content="24/7 Bike Roadside Assistance & Doorstep Service in Chennai" />
        <meta name="subheadings" content="24/7 Roadside Assistance, On-Demand Mechanics, Tow and Transport" />

        {/* SCHEMA 1 */}
        <script type="application/ld+json">
          {`
{
  "@context": "https://schema.org",
  "@type": "Organization",
  "name": "MotoDoctor",
  "url": "https://www.motodoctor.in",
  "logo": "https://www.motodoctor.in/static/media/Moto-Doc-Logo.dae1a58c6b5b5e7d510d8c23a099beff.svg",
  "description": "24/7 bike service and bike repair in Chennai. Flat tire, battery trouble or breakdown? Get instant roadside help and towing anytime.",
  "areaServed": {
    "@type": "City",
    "name": "Chennai"
  },
  "sameAs": [
    "https://play.google.com/store/apps/details?id=com.vahaninc.autodoctor",
    "https://apps.apple.com/in/app/motodoctor-rider/id6478849754"
  ]
}
          `}
        </script>

        {/* SCHEMA 2 */}
        <script type="application/ld+json">
          {`
{
  "@context": "https://schema.org",
  "@type": "Service",
  "serviceType": "24/7 Bike Roadside Assistance",
  "provider": {
    "@type": "Organization",
    "name": "MotoDoctor",
    "url": "https://www.motodoctor.in"
  },
  "areaServed": {
    "@type": "City",
    "name": "Chennai"
  },
  "description": "24/7 bike service and bike repair in Chennai. Flat tire, battery trouble or breakdown? Get instant roadside help and towing anytime."
}
          `}
        </script>

        {/* SCHEMA 3 */}
        <script type="application/ld+json">
          {`
{
  "@context": "https://schema.org",
  "@type": "MobileApplication",
  "name": "MotoDoctor",
  "operatingSystem": "Android, iOS",
  "applicationCategory": "UtilityApplication",
  "downloadUrl": [
    "https://play.google.com/store/apps/details?id=com.vahaninc.autodoctor",
    "https://apps.apple.com/in/app/motodoctor-rider/id6478849754"
  ],
  "offers": {
    "@type": "Offer",
    "price": "0",
    "priceCurrency": "INR"
  },
  "description": "24/7 bike service and bike repair in Chennai. Flat tire, battery trouble or breakdown? Get instant roadside help and towing anytime."
}
          `}
        </script>
      </Helmet>

      <Hero />
      <Content5 />
      <WhyChooseUs />
      <HowItWorks />
      {/* <TestimonialSlider /> */}
      <Content4 />
      <BoxSlider />
      <Content8 />
      {/* <MotoDoctorBenefits/> */}
      {/* <ContactUs/> */}
      {/* {service-page} */}
      {/* <Content6 />
      <PickupDrop /> */}
      {/* about-page */}
      {/* <Mission />
      <ServiceCommitment /> */}
      {/* <Content1 /> */}
      {/* faq */}
      {/* <FAQ /> */}
      {/* <QuickAccess /> */}
      {/* <Content10 /> */}
      {/* <Content7 />  */}
      {/* <Content9 /> */}
    </div>
  );
}

export default Home;
